import { COOKIE_FONT_FAMILY, ensureCookieFontInjected } from './get-font-face-rule';

// The SDK serializes the profile's globalConfig.font into a `fontConfig`
// query param on the iframe URL (it always has the profile before setting
// iframe.src). Reading it here — before React renders — starts the woff2
// download in parallel with app bootstrap instead of after the
// IFRAME_READY -> CONFIG_FROM_SDK round trip, so the modals' font-readiness
// gate resolves near-instantly.
//
// The param is untrusted input: ensureCookieFontInjected validates every
// entry (https-only URLs, WEIGHT_\d{3} keys) via the shared helpers, so a
// crafted param can at worst load an https woff2 into the synthetic family.
const preloadCookieFontFromQuery = () => {
  try {
    // Local dev URLs can produce a `//cookie-center` pathname (trailing-slash
    // collector base), so match by suffix rather than equality.
    const path = window.location.pathname.replace(/\/+$/, '');
    if (!path.endsWith('/cookie-center')) return;

    const raw = new URLSearchParams(window.location.search).get('fontConfig');
    if (!raw) return;

    const fontConfig = JSON.parse(raw);
    const weights = ensureCookieFontInjected(fontConfig);
    if (!document.fonts?.load) return;
    weights.forEach(({ weight }) => {
      document.fonts.load(`${weight} 1em ${COOKIE_FONT_FAMILY}`).catch(() => {});
    });
  } catch {
    // Malformed param or unavailable API — never let the preload break bootstrap.
  }
};

export default preloadCookieFontFromQuery;
